import { FC } from 'react';
import { PageTitle, SectionTitle, SectionContent, SectionsList } from '../styles';

export const PrivacyPolicyOnlinesKz: FC = () => {
  return (
    <>
      <PageTitle>Политика конфиденциальности и обработки персональных данных</PageTitle>
      <SectionsList>
        <li>
          <SectionTitle>1. Общие положения. Стороны. Цель документа</SectionTitle>
        </li>
        <SectionContent>
          <p>
            1.1. Настоящая Политика определяет порядок и условия обработки Товариществом с ограниченной ответственностью
            &quot;VIRTON (ВИРТОН)&quot;, компанией, учрежденной и действующей по адресу: 050040, Казахстан, город
            Алматы, Бостандыкский район, улица Байзакова, здание 280, БИН 220340010538 (&laquo;Мы&raquo; или &laquo;Администратор&raquo;)
            информации о физическом лице которая может быть получена Администратором от этого физического лица либо от
            его законного представителя (&laquo;Вы&raquo; или &laquo;Пользователь&raquo;), при возникновении следующих
            отношений с Пользователем:
          </p>
          <ul>
            <li>при использовании Пользователем веб-сайта, расположенного по адресу: <a href="https://onlinesdesign.com">https://onlinesdesign.com</a>, включая все его домены,
              поддомены и страницы, любое их содержимое (информацию), программное обеспечение, предлагаемое Исполнителем к
              использованию на этом сайте или на ресурсах третьих лиц, в том числе программы для ЭВМ, приложения для мобильных
              устройств, интерфейсы и системы (например, API и виджеты), а также любые их функции (далее &ndash; &laquo;Платформа&raquo;).
              Использование Платформы регулируется Офертой на оказание услуг, доступной по адресу: <a href="https://onlinesdesign.com/legals/offer">https://onlinesdesign.com/legals/offer</a>{' '}
              и регулирующими документами, перечисленными в Оферте;
            </li>
            <li>при осуществлении Администратором прав и обязанностей, установленных соглашениями и договорами, заключенными
              между Администратором и Пользователем;
            </li>
            <li>при обработке обращений, жалоб, запросов, сообщений, направляемых Администратором и Пользователем друг другу.
            </li>
          </ul>
          <p>
            1.2. Целью и назначением настоящей Политики является обеспечение надлежащего правового режима персональной
            информации, которая может включать в себя и персональные данные.
          </p>
          <p>
            1.3. Правовыми основаниями обработки персональной информации являются:
          </p>
          <ul>
            <li>согласие на обработку персональных данных;</li>
            <li>устав Администратора;</li>
            <li>законы и принятые на их основе нормативные правовые акты, регулирующие отношения, связанные с информацией и
              информационными технологиями;
            </li>
            <li>соглашения, заключаемые между Администратором и Пользователем;</li>
            <li>Общий регламент защиты данных Европейского союза (GDPR или (EU) 2016/679) в случае, если он должен применяться к
              правоотношениям Сторон по критерию экстерриториальности, закрепленному в нём.
            </li>
          </ul>
          <p>
            1.4. Используя любые функции Платформы или вступая с Администратором в иные отношения, предусмотренные пунктом
            1.1. и Офертой, Пользователь выражает полное согласие с условиями настоящей Политики. В случае несогласия с
            условиями настоящей Политики использование Платформы, либо совершение иных действий в рамках правоотношений,
            предусмотренных пунктом 1.1., должно быть немедленно прекращено.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Правила сбора и обработки персональной информации</SectionTitle>
        </li>
        <SectionContent>
          <p className="bold">2.1. Цель сбора и обработки персональной информации</p>
          <p>
            2.1.1. Администратор обрабатывает персональную информацию в следующих целях (вместе - &laquo;Цель обработки&raquo;):
            <ul>
              <li>
                для&nbsp;идентификации стороны в рамках соглашений и договоров, исполнения договорных обязательств перед
                Пользователем, включая обеспечение функций Платформы;
              </li>
              <li>
                для&nbsp;соблюдения требований действующего законодательства (в том числе в целях предупреждения или пресечения
                незаконных или противоправных действий Пользователя или третьих лиц);
              </li>
              <li>
                для&nbsp;связи с Пользователем, направления Пользователю&nbsp;сообщений, уведомлений, запросов, ответов,
                документов о платежах и расчетах, документов, имеющих правовое значение;
              </li>
              <li>
                для&nbsp;направления Пользователю сообщений рекламного или информационного характера с учетом ограничений
                соответствующего раздела Политики;
              </li>
              <li>
                для&nbsp;проверки, исследования и анализа данных, позволяющих поддерживать и улучшать функции Платформы, а также
                разрабатывать новые функции;
              </li>
              <li>для&nbsp;проведения статистических и иных исследований на основе обезличенных данных;</li>
              <li>
                для того, чтобы предлагать Пользователю посетить иные сайты и другие веб-ресурсы Администратора или третьих лиц,
                предлагать Пользователю продукты Администратора или третьих лиц, которые, по мнению Администратора, могут
                заинтересовать Пользователя (т. е. показывать Пользователю рекламу, учитывающую его интересы);
              </li>
              <li>
                для того, чтобы осуществить защиту прав Сторон или прав третьих лиц.
              </li>
            </ul>
          </p>
          <p>
            2.1.2. Обработка персональной информации, в том числе персональных данных, будет ограничиваться достижением
            этих конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных,
            несовместимая с целями сбора персональных данных.
          </p>
          <p className="bold">2.2. Субъекты персональных данных. Объем и категории информации</p>
          <p>
            2.2.1. Субъектом персональных данных является:
            <ul>
              <li>
                физическое лицо, которое передало свои персональные данные Администратору самостоятельно;
              </li>
              <li>
                законный представитель физического лица, если данные передал такой представитель;
              </li>
              <li>физические лица - представители и работники юридических лиц.&nbsp;</li>
            </ul>
          </p>
          <p>
            2.2.2. Для каждой категории субъектов в состав персональной информации включаются следующие данные, которые
            собираются и обрабатываются следующим образом:
            <ul>
              <li>
                <strong>Данные,</strong> <strong>предоставленные Пользователем самостоятельно</strong> при использовании функций
                Платформы: имя, фамилия, адрес электронной почты;
              </li>
              <li>
                <strong>Данные, которые автоматически передаются оборудованию</strong> <strong>Администратора</strong> в
                процессе соединения с установленным на устройстве Пользователя программным обеспечением: IP-адрес, информация
                файлов cookie, информация о браузере пользователя (или иной программе, с помощью которой осуществляется доступ),
                информация об аппаратном и программном обеспечении, данные сети wi-fi или проводной сети, дата и время доступа,
                адреса и содержание запросов, http/https заголовки, веб-маяки и пиксельные теги;
              </li>
              <li>
                <strong>Информация об активности во время использования Платформы</strong>: история действий, данные о
                посещенных страницах или разделах, лайки и предпочтения, иное взаимодействие с интерфейсом Платформы;
              </li>
              <li>
                <strong>Данные о геолокации (информация о месте нахождения оборудования Пользователя),</strong> если
                Пользователь разрешил оборудованию предоставлять ее;
              </li>
              <li><strong>Данные документа, удостоверяющего личность, который может предоставляться Пользователем по требованию
                Администратора в случае, когда Пользователь просит о совершении каких-либо юридически значимых
                действий:&nbsp;</strong>серия и номер документа, выдавший орган и его код, дата и место выдачи, фотографии в
                документе;
              </li>
              <li><strong>Данные привязанной банковской карты, если Пользователь выполняет привязку карты к
                Платформе:&nbsp;</strong>номер банковской карты, срок действия банковской карты, защитный код банковской карты.
              </li>
            </ul>
          </p>
          <p>
            2.2.3. <strong>О специальных категориях персональных данных:</strong> Администратор не собирает и не
            обрабатывает данные, относимые к специальным (чувствительным) категориям персональных данных, в том
            числе данные о расовом и национальном происхождении, о политических и религиозных взглядах, о здоровье,
            биометрические данные и тому подобные данные.
          </p>
          <p className="bold">2.3. Порядок и условия обработки персональных данных</p>
          <p>
            2.3.1. Обработка персональных данных &ndash; любое действие (операция) или совокупность действий (операций) с
            персональными данными, совершаемых с использованием средств автоматизации или без их использования.
            Осуществляя обработку персональных данных, Администратор будет осуществлять следующие действия: сбор;
            запись; систематизацию; накопление; хранение; уточнение (обновление, изменение); извлечение;
            использование; передачу (распространение, предоставление, доступ); обезличивание; блокирование;
            удаление; уничтожение.
          </p>
          <p>
            2.3.2. Администратор может обрабатывать персональную информацию указанными выше способами (операциями) как в
            информационных системах персональных данных, так и без использования средств автоматизации.&nbsp;
          </p>
          <p>
            2.3.3. Администратор будет обрабатывать персональную информацию Пользователя столько времени, сколько это
            необходимо для достижения конкретной цели, для которой она была собрана, или для соблюдения требований
            законодательства.
          </p>
          <p>
            2.3.4. В случае отзыва Пользователем согласия на обработку персональных данных или истечения срока действия
            такого согласия, Администратор вправе заблокировать эти данные от редактирования и обрабатывать их в
            архивном виде в течение 3 (трёх) лет.
          </p>
          <p className="bold">2.4. Меры по защите информации</p>
          <p>
            2.4.1. Администратор принимает все необходимые меры для защиты персональных данных Пользователя от
            несанкционированного, случайного или незаконного уничтожения, потери, изменения, недобросовестного
            использования, раскрытия или доступа, а также иных незаконных форм обработки.
          </p>
          <p>
            2.4.2. По умолчанию персональная информация обрабатывается автоматическим оборудованием без доступа к ней
            кого-либо. В случае если такой доступ понадобится, то Администратор предоставляет доступ к персональным
            данным Пользователя только тем лицам, которым эта информация необходима для обеспечения Цели обработки.
            Для защиты и обеспечения конфиденциальности данных такие лица должны обязаться соблюдать внутренние
            правовые правила и процедуры, законодательство, технические и организационные меры безопасности в
            отношении обработки персональной информации.&nbsp;
          </p>
          <p>
            2.4.3. Как при обработке персональных данных без использования средств автоматизации, так и при
            автоматизированной обработке обеспечивается достаточная безопасность места, где происходит обработка
            персональных данных.
          </p>
          <p>
            2.4.4. Раскрытие предоставленной Пользователем информации может быть произведено лишь в соответствии с
            действующим законодательством по требованию суда, правоохранительных органов, и в иных предусмотренных
            законодательством случаях.&nbsp;
          </p>
          <p>
            2.4.5. Администратор не проверяет достоверность информации, предоставляемой Пользователем, и исходит из того,
            что Пользователь в порядке принципа добросовестности предоставляет достоверную и достаточную информацию,
            заботится о своевременности внесения изменений в ранее предоставленную информацию,&nbsp;актуализирует
            информацию.
          </p>
          <p className="bold">2.5. Правила о передаче персональной информации третьим лицам</p>
          <p>
            2.5.1. Администратор вправе передать персональную информацию следующим третьим лицам:
            <ul>
              <li>
                в отношении которых произведена уступка (перевод) прав или обязанностей, либо новация по соответствующему
                соглашению (например, при правопреемстве, при продаже бизнеса в целом или части бизнеса);
              </li>
              <li>
                любому национальному или международному регулирующему органу, правоохранительным органам, центральным или
                местным органам власти, другим официальным или государственным органам или судам, которым Администратор обязан
                по запросу предоставлять информацию в соответствии с применимым законодательством;&nbsp;
              </li>
              <li>
                в случае если Пользователь сам выразил согласие на передачу персональной информации третьему лицу, либо передача
                персональной информации требуется для предоставления определенной функции Платформы или для выполнения
                определенного соглашения или договора, заключенного с Пользователем;
              </li>
              <li>
                в целях обеспечения правовой защиты Администратора или третьих лиц при нарушении их прав либо угрозе нарушения
                их прав, включая нарушение законов или иных регулирующих документов.
              </li>
            </ul>
          </p>
          <p>
            2.5.2. Пользователь вправе разрешать и запрещать свободное распространение категорий персональной информации
            путем применения настроек видимости в своей учетной записи.
          </p>
          <p className="bold">
            2.6. Права и обязанности в отношении персональной информации. Представитель
          </p>
          <p>
            2.6.1. Пользователь обязан заботиться о достоверности предоставленной информации, о своевременности внесения
            изменений в предоставленную информацию, ее актуализации, в противном случае Администратор не несет
            ответственности за неисполнение обязательств, любые убытки, вред или потери.
          </p>
          <p>
            2.6.2. <strong>О представителях:</strong> Пользователь вправе разрешать, ограничивать или запрещать обработку
            персональных данных третьих лиц только на основании представительства, установленного законом (например,
            родители и опекуны) или сделкой (например, доверенность), дающего ему право давать разрешения на
            обработку персональной информации за третье лицо и нести иные права и обязанности в интересах такого
            третьего лица. Если Пользователь не имеет права дать такое разрешение или утратил право дать такое
            разрешение, то он обязан воздержаться от передачи данных или прекратить передачу данных (и удалить ранее
            переданные данные) соответственно, а в случае появления соответствующих претензий он обязуется
            самостоятельно разрешить противоречия и освободить Администратора от соответствующих требований. В
            случае несоблюдения этих требований Пользователь обязан возместить Администратору все убытки и иные
            потери, вызванные несоблюдением указанных требований.
          </p>
          <p className="bold">
            2.7. Дополнение, исправление, блокировка и удаление персональных данных, процедура реагирования на
            запросы субъекта на доступ к его персональным данным
          </p>
          <p>
            2.7.1. Пользователь может дополнить и исправить персональную информацию, воспользовавшись соответствующими
            функциями своей учетной записи, а если функции учетной записи не достаточны по мнению Пользователя
            &ndash; путем направления письменного обращения на адрес электронной почты Администратора, указанный в
            настоящей Политике.
          </p>
          <p>
            2.7.2. Пользователь может заблокировать и удалить персональную информацию, воспользовавшись соответствующими
            функциями своей учетной записи, а если функции учетной записи не достаточны по мнению Пользователя
            &ndash; путем направления письменного обращения на адрес электронной почты Администратора, указанный в
            настоящей Политике.
          </p>
          <p>
            2.7.3. Иные права субъекта персональных данных реализуются в аналогичном порядке: для реализации права
            Пользователь может воспользоваться соответствующими функциями своей учетной записи, а если функции
            учетной записи не достаточны по мнению Пользователя &ndash; путем направления письменного обращения на
            адрес электронной почты Администратора, указанный в настоящей Политике.
          </p>
          <p className="bold">
            2.7.4. Пользователь имеет право:
            <ul>
              <li>запрашивать информацию об осуществляемой обработке персональных данных;</li>
              <li>отзывать согласие на обработку персональной информации;</li>
              <li>требовать ограничений на обработку персональной информации;</li>
              <li>
                требовать прекратить обработку персональной информации, если это предусмотрено применимым законодательством и
                настоящей Политикой.
              </li>
            </ul>
          </p>
          <p>
            2.7.5. В случаях, предусмотренных применимым законодательством, Пользователь может также обладать другими
            правами, не указанными выше.
          </p>
          <p>
            2.7.6. Пользователь обязуется воспользоваться реквизитами (контактной информацией) из настоящей Политики для
            направления запросов о реализации прав субъекта персональных данных или жалоб относительно
            некорректности информации или незаконности ее обработки. Такие запросы и жалобы рассматриваются в срок,
            не превышающий 30 (Тридцати) календарных дней с даты поступления Администратору.
          </p>
          <p>
            2.7.7. Если Пользователь не удовлетворен результатами рассмотрения запроса или жалобы, то он имеет право подать
            запрос или жалобу в орган государственной власти, уполномоченный осуществлять защиту прав субъектов
            персональных данных.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Уведомления и связь сторон</SectionTitle>
        </li>
        <SectionContent>
          <p>
            3.1. Пользователь соглашается получать от Администратора сообщения по адресу электронной почты и по абонентскому
            номеру телефона, указанные Пользователем при использовании функций Платформы (далее &ndash; &laquo;Нотификации&raquo;).&nbsp;
          </p>
          <p>
            3.2. Пользователь вправе отозвать свое согласие на получение Нотификаций:
            <ul>
              <li>кликнув по ссылке &laquo;Отписаться&raquo; внизу письма;&nbsp;</li>
              <li>путем направления уведомления на электронную почту Администратора.</li>
            </ul>
          </p>
          <p>
            3.3. Пользователь согласен с тем, что Администратор прекращает направление Нотификаций не ранее чем через 24 часа
            после выполнения указанных действий.
          </p>
          <p>
            Администратор вправе использовать Нотификации для:
            <ul>
              <li>информирования Пользователя о работе функций Платформы;</li>
              <li>информирования Пользователя об изменении регулирующих документов;</li>
              <li>направления Пользователю сообщений и рассылок информационного характера;</li>
              <li>направления Пользователю сообщений и рассылок рекламного характера.</li>
            </ul>
          </p>
          <p>
            3.5. Пользователь в свою очередь обязуется направлять все сообщения, уведомления, заявления и документы (включая
            и сообщения, которые представляют собой ответы на Нотификации) по адресу электронной почты Администратора,
            указанному в настоящей Политике.
          </p>
          <p>
            3.6. Документы, которые по мнению Администратора имеют юридическое значение, Администратор вправе запросить в
            бумажном виде. Такие документы, а также документы, которые Пользователь сам считает необходимым направить в
            бумажном виде, направляются по адресу места нахождения Администратора, указанному в настоящей Политике.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Изменение Политики конфиденциальности. Применимое законодательство</SectionTitle>
        </li>
        <SectionContent>
          <p>
            4.1. Администратор имеет право вносить изменения в настоящую Политику. При внесении изменений в тексте актуальной
            редакции указывается дата последнего обновления. Новая редакция Политики вступает в силу с момента ее
            размещения, если иное не предусмотрено новой редакцией Политики. Утратившие силу редакции доступны в
            веб-архиве по указанному в Политике адресу.
          </p>
          <p>
            4.2. Местом выражения согласия с Политикой и местом исполнения Политики всегда является место нахождения
            Администратора, а правом, применимым к отношениям Администратора и Пользователя, всегда является право
            Республики Казахстан, вне зависимости от того, где находится Пользователь или оборудование, используемое им.
            Все споры и разногласия разрешаются по месту нахождения Администратора. Исключение составляют случаи, когда
            правоотношения Сторон подпадают под экстерриториальные критерии Общего регламента защиты данных Европейского
            союза (&laquo;GDPR&raquo; или &laquo;(ЕС) 2016/679&raquo;). В таком случае право, применимое к отношениям
            между Администратором и Пользователем, будет состоять в совокупности из законодательства Республики
            Казахстан и правил регламента GDPR, включая и правила разрешения споров и разногласий между участниками
            процесса обработки персональной информации.
          </p>
          <p>
            4.3. В случае, если Политика доступна на нескольких языках, правовой приоритет при толковании имеет версия на
            русском языке.
          </p>
          <p>
            4.4. Политика начинает регулировать отношения Пользователя и Администратора с момента выражения Пользователем
            согласия с ее условиями и действует бессрочно. Бессрочность действия Политики как документа никаким образом
            не означает бессрочность/отсутствие ограничений срока обработки персональных данных. Одностороннее
            прекращение действия Политики по воле одной из сторон не допускается.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Правила для Пользователей, находящихся в Европейском Союзе</SectionTitle>
        </li>
        <SectionContent>
          <p>
            5.1. В случае, если Вы разрешили своему оборудованию предоставлять данные о геолокации, и из
            содержимого этих данных Мы можем определить Ваше местоположение внутри Европейского Союза (ЕС), Мы обязаны
            предоставить Вам дополнительные права и гарантии в соответствии с Европейским общим регламентом защиты
            данных (&laquo;GDPR&raquo; или &laquo;(ЕС) 2016/679&raquo;), если правоотношения Сторон подпадают под его
            экстерриториальные критерии.
          </p>
          <p>
            5.2. Пользователь признает, что местоположение оборудования Пользователя, которое передает
            данные Администратору, должно быть единственным технически возможным способом идентифицировать Пользователя
            как резидента ЕС. Если Пользователь использует какие-либо средства для маскирования своего местоположения
            или какие-либо средства, которые потенциально могут вызвать такое маскирование, тогда Администратор не может
            идентифицировать Пользователя как Сторону, подпадающую под действие GDPR и, следовательно, отношения между
            Пользователем и Администратором не подлежат регулированию GDPR.
          </p>
          <p>
            5.3. Отношения между Пользователем и Администратором подпадают под действие GDPR с момента,
            когда Мы определяем Ваше местоположение в ЕС и до момента, когда Мы определяем Ваше новое местоположение за
            пределами ЕС.
          </p>
          <p>
            5.4. Основные права и гарантии GDPR для физических лиц следующие:&nbsp;
            <ul>
              <li>право на получение информации;</li>
              <li>право доступа;&nbsp;</li>
              <li>право на исправление;&nbsp;</li>
              <li>право на удаление;&nbsp;</li>
              <li>право на ограничение обработки;&nbsp;</li>
              <li>право на переносимость данных;&nbsp;</li>
              <li>право на возражение;&nbsp;</li>
              <li>права, связанные с автоматическим принятием решений (включая профилирование).</li>
            </ul>
          </p>
          <p>
            5.5. В случаях, предусмотренных применимым законодательством, Пользователь может также
            обладать другими правами и гарантиями, не указанными выше.
          </p>
          <p>
            5.6. Для реализации права или гарантии Пользователь может воспользоваться соответствующими
            функциями своей учетной записи, а если функции учетной записи не достаточны по мнению Пользователя &ndash;
            путем направления письменного обращения на адрес электронной почты Администратора, указанный в настоящей
            Политике.
          </p>
          <p>
            5.7. Если Администратор использует какую-либо стороннюю службу обработки данных для обработки
            персональных данных, он должен обеспечить полное соответствие обработчика данных требованиям GDPR и
            предоставить Пользователю запрошенную информацию о таком обработчике данных.
          </p>
          <p>
            5.8. Пользователь полностью осознает и принимает тот факт, что распространение правил GDPR на
            отношения Сторон никоим образом не влечет и не указывает на применение каких-либо иных актов
            законодательства Европейского Союза к отношениям Сторон.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Реквизиты Администратора. Контактная информация</SectionTitle>
        </li>
        <SectionContent>
          <p>Товарищество с ограниченной ответственностью &quot;VIRTON (ВИРТОН)&quot;.</p>
          <p>050040, Казахстан, город Алматы, Бостандыкский район, улица Байзакова, здание 280, БИН 220340010538.</p>
          <p>
            Адрес электронной почты: <a href="mailto:hello@onlines.design">hello@onlines.design</a>
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Сведения о редакции документа</SectionTitle>
        </li>
        <SectionContent>
          <p>Дата публикации этой редакции документа: 1 ноября 2022 г.</p>
        </SectionContent>
      </SectionsList>
    </>
  );
};
import { FC } from 'react';
import { PageTitle, SectionTitle, SectionContent, SectionsList } from '../styles';

export const PrivacyPolicyOnlinesKz: FC = () => {
  return (
    <>
      <PageTitle>Политика конфиденциальности и обработки персональных данных</PageTitle>
      <SectionsList>
        <li>
          <SectionTitle>1. Общие положения. Стороны. Цель документа</SectionTitle>
        </li>
        <SectionContent>
          <p>
            1.1. Настоящая Политика определяет порядок и условия обработки Товариществом с ограниченной ответственностью
            &quot;VIRTON (ВИРТОН)&quot;, компанией, учрежденной и действующей по адресу: 050040, Казахстан, город
            Алматы, Бостандыкский район, улица Байзакова, здание 280, БИН 220340010538 (&laquo;Мы&raquo; или &laquo;Администратор&raquo;)
            информации о физическом лице которая может быть получена Администратором от этого физического лица либо от
            его законного представителя (&laquo;Вы&raquo; или &laquo;Пользователь&raquo;), при возникновении следующих
            отношений с Пользователем:
          </p>
          <ul>
            <li>при использовании Пользователем веб-сайта, расположенного по адресу: <a href="https://onlinesdesign.com">https://onlinesdesign.com</a>, включая все его домены,
              поддомены и страницы, любое их содержимое (информацию), программное обеспечение, предлагаемое Исполнителем к
              использованию на этом сайте или на ресурсах третьих лиц, в том числе программы для ЭВМ, приложения для мобильных
              устройств, интерфейсы и системы (например, API и виджеты), а также любые их функции (далее &ndash; &laquo;Платформа&raquo;).
              Использование Платформы регулируется Офертой на оказание услуг, доступной по адресу: <a href="https://onlinesdesign.com/legals/offer">https://onlinesdesign.com/legals/offer</a>{' '}
              и регулирующими документами, перечисленными в Оферте;
            </li>
            <li>при осуществлении Администратором прав и обязанностей, установленных соглашениями и договорами, заключенными
              между Администратором и Пользователем;
            </li>
            <li>при обработке обращений, жалоб, запросов, сообщений, направляемых Администратором и Пользователем друг другу.
            </li>
          </ul>
          <p>
            1.2. Целью и назначением настоящей Политики является обеспечение надлежащего правового режима персональной
            информации, которая может включать в себя и персональные данные.
          </p>
          <p>
            1.3. Правовыми основаниями обработки персональной информации являются:
          </p>
          <ul>
            <li>согласие на обработку персональных данных;</li>
            <li>устав Администратора;</li>
            <li>законы и принятые на их основе нормативные правовые акты, регулирующие отношения, связанные с информацией и
              информационными технологиями;
            </li>
            <li>соглашения, заключаемые между Администратором и Пользователем;</li>
            <li>Общий регламент защиты данных Европейского союза (GDPR или (EU) 2016/679) в случае, если он должен применяться к
              правоотношениям Сторон по критерию экстерриториальности, закрепленному в нём.
            </li>
          </ul>
          <p>
            1.4. Используя любые функции Платформы или вступая с Администратором в иные отношения, предусмотренные пунктом
            1.1. и Офертой, Пользователь выражает полное согласие с условиями настоящей Политики. В случае несогласия с
            условиями настоящей Политики использование Платформы, либо совершение иных действий в рамках правоотношений,
            предусмотренных пунктом 1.1., должно быть немедленно прекращено.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Правила сбора и обработки персональной информации</SectionTitle>
        </li>
        <SectionContent>
          <p className="bold">2.1. Цель сбора и обработки персональной информации</p>
          <p>
            2.1.1. Администратор обрабатывает персональную информацию в следующих целях (вместе - &laquo;Цель обработки&raquo;):
            <ul>
              <li>
                для&nbsp;идентификации стороны в рамках соглашений и договоров, исполнения договорных обязательств перед
                Пользователем, включая обеспечение функций Платформы;
              </li>
              <li>
                для&nbsp;соблюдения требований действующего законодательства (в том числе в целях предупреждения или пресечения
                незаконных или противоправных действий Пользователя или третьих лиц);
              </li>
              <li>
                для&nbsp;связи с Пользователем, направления Пользователю&nbsp;сообщений, уведомлений, запросов, ответов,
                документов о платежах и расчетах, документов, имеющих правовое значение;
              </li>
              <li>
                для&nbsp;направления Пользователю сообщений рекламного или информационного характера с учетом ограничений
                соответствующего раздела Политики;
              </li>
              <li>
                для&nbsp;проверки, исследования и анализа данных, позволяющих поддерживать и улучшать функции Платформы, а также
                разрабатывать новые функции;
              </li>
              <li>для&nbsp;проведения статистических и иных исследований на основе обезличенных данных;</li>
              <li>
                для того, чтобы предлагать Пользователю посетить иные сайты и другие веб-ресурсы Администратора или третьих лиц,
                предлагать Пользователю продукты Администратора или третьих лиц, которые, по мнению Администратора, могут
                заинтересовать Пользователя (т. е. показывать Пользователю рекламу, учитывающую его интересы);
              </li>
              <li>
                для того, чтобы осуществить защиту прав Сторон или прав третьих лиц.
              </li>
            </ul>
          </p>
          <p>
            2.1.2. Обработка персональной информации, в том числе персональных данных, будет ограничиваться достижением
            этих конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных,
            несовместимая с целями сбора персональных данных.
          </p>
          <p className="bold">2.2. Субъекты персональных данных. Объем и категории информации</p>
          <p>
            2.2.1. Субъектом персональных данных является:
            <ul>
              <li>
                физическое лицо, которое передало свои персональные данные Администратору самостоятельно;
              </li>
              <li>
                законный представитель физического лица, если данные передал такой представитель;
              </li>
              <li>физические лица - представители и работники юридических лиц.&nbsp;</li>
            </ul>
          </p>
          <p>
            2.2.2. Для каждой категории субъектов в состав персональной информации включаются следующие данные, которые
            собираются и обрабатываются следующим образом:
            <ul>
              <li>
                <strong>Данные,</strong> <strong>предоставленные Пользователем самостоятельно</strong> при использовании функций
                Платформы: имя, фамилия, адрес электронной почты;
              </li>
              <li>
                <strong>Данные, которые автоматически передаются оборудованию</strong> <strong>Администратора</strong> в
                процессе соединения с установленным на устройстве Пользователя программным обеспечением: IP-адрес, информация
                файлов cookie, информация о браузере пользователя (или иной программе, с помощью которой осуществляется доступ),
                информация об аппаратном и программном обеспечении, данные сети wi-fi или проводной сети, дата и время доступа,
                адреса и содержание запросов, http/https заголовки, веб-маяки и пиксельные теги;
              </li>
              <li>
                <strong>Информация об активности во время использования Платформы</strong>: история действий, данные о
                посещенных страницах или разделах, лайки и предпочтения, иное взаимодействие с интерфейсом Платформы;
              </li>
              <li>
                <strong>Данные о геолокации (информация о месте нахождения оборудования Пользователя),</strong> если
                Пользователь разрешил оборудованию предоставлять ее;
              </li>
              <li><strong>Данные документа, удостоверяющего личность, который может предоставляться Пользователем по требованию
                Администратора в случае, когда Пользователь просит о совершении каких-либо юридически значимых
                действий:&nbsp;</strong>серия и номер документа, выдавший орган и его код, дата и место выдачи, фотографии в
                документе;
              </li>
              <li><strong>Данные привязанной банковской карты, если Пользователь выполняет привязку карты к
                Платформе:&nbsp;</strong>номер банковской карты, срок действия банковской карты, защитный код банковской карты.
              </li>
            </ul>
          </p>
          <p>
            2.2.3. <strong>О специальных категориях персональных данных:</strong> Администратор не собирает и не
            обрабатывает данные, относимые к специальным (чувствительным) категориям персональных данных, в том
            числе данные о расовом и национальном происхождении, о политических и религиозных взглядах, о здоровье,
            биометрические данные и тому подобные данные.
          </p>
          <p className="bold">2.3. Порядок и условия обработки персональных данных</p>
          <p>
            2.3.1. Обработка персональных данных &ndash; любое действие (операция) или совокупность действий (операций) с
            персональными данными, совершаемых с использованием средств автоматизации или без их использования.
            Осуществляя обработку персональных данных, Администратор будет осуществлять следующие действия: сбор;
            запись; систематизацию; накопление; хранение; уточнение (обновление, изменение); извлечение;
            использование; передачу (распространение, предоставление, доступ); обезличивание; блокирование;
            удаление; уничтожение.
          </p>
          <p>
            2.3.2. Администратор может обрабатывать персональную информацию указанными выше способами (операциями) как в
            информационных системах персональных данных, так и без использования средств автоматизации.&nbsp;
          </p>
          <p>
            2.3.3. Администратор будет обрабатывать персональную информацию Пользователя столько времени, сколько это
            необходимо для достижения конкретной цели, для которой она была собрана, или для соблюдения требований
            законодательства.
          </p>
          <p>
            2.3.4. В случае отзыва Пользователем согласия на обработку персональных данных или истечения срока действия
            такого согласия, Администратор вправе заблокировать эти данные от редактирования и обрабатывать их в
            архивном виде в течение 3 (трёх) лет.
          </p>
          <p className="bold">2.4. Меры по защите информации</p>
          <p>
            2.4.1. Администратор принимает все необходимые меры для защиты персональных данных Пользователя от
            несанкционированного, случайного или незаконного уничтожения, потери, изменения, недобросовестного
            использования, раскрытия или доступа, а также иных незаконных форм обработки.
          </p>
          <p>
            2.4.2. По умолчанию персональная информация обрабатывается автоматическим оборудованием без доступа к ней
            кого-либо. В случае если такой доступ понадобится, то Администратор предоставляет доступ к персональным
            данным Пользователя только тем лицам, которым эта информация необходима для обеспечения Цели обработки.
            Для защиты и обеспечения конфиденциальности данных такие лица должны обязаться соблюдать внутренние
            правовые правила и процедуры, законодательство, технические и организационные меры безопасности в
            отношении обработки персональной информации.&nbsp;
          </p>
          <p>
            2.4.3. Как при обработке персональных данных без использования средств автоматизации, так и при
            автоматизированной обработке обеспечивается достаточная безопасность места, где происходит обработка
            персональных данных.
          </p>
          <p>
            2.4.4. Раскрытие предоставленной Пользователем информации может быть произведено лишь в соответствии с
            действующим законодательством по требованию суда, правоохранительных органов, и в иных предусмотренных
            законодательством случаях.&nbsp;
          </p>
          <p>
            2.4.5. Администратор не проверяет достоверность информации, предоставляемой Пользователем, и исходит из того,
            что Пользователь в порядке принципа добросовестности предоставляет достоверную и достаточную информацию,
            заботится о своевременности внесения изменений в ранее предоставленную информацию,&nbsp;актуализирует
            информацию.
          </p>
          <p className="bold">2.5. Правила о передаче персональной информации третьим лицам</p>
          <p>
            2.5.1. Администратор вправе передать персональную информацию следующим третьим лицам:
            <ul>
              <li>
                в отношении которых произведена уступка (перевод) прав или обязанностей, либо новация по соответствующему
                соглашению (например, при правопреемстве, при продаже бизнеса в целом или части бизнеса);
              </li>
              <li>
                любому национальному или международному регулирующему органу, правоохранительным органам, центральным или
                местным органам власти, другим официальным или государственным органам или судам, которым Администратор обязан
                по запросу предоставлять информацию в соответствии с применимым законодательством;&nbsp;
              </li>
              <li>
                в случае если Пользователь сам выразил согласие на передачу персональной информации третьему лицу, либо передача
                персональной информации требуется для предоставления определенной функции Платформы или для выполнения
                определенного соглашения или договора, заключенного с Пользователем;
              </li>
              <li>
                в целях обеспечения правовой защиты Администратора или третьих лиц при нарушении их прав либо угрозе нарушения
                их прав, включая нарушение законов или иных регулирующих документов.
              </li>
            </ul>
          </p>
          <p>
            2.5.2. Пользователь вправе разрешать и запрещать свободное распространение категорий персональной информации
            путем применения настроек видимости в своей учетной записи.
          </p>
          <p className="bold">
            2.6. Права и обязанности в отношении персональной информации. Представитель
          </p>
          <p>
            2.6.1. Пользователь обязан заботиться о достоверности предоставленной информации, о своевременности внесения
            изменений в предоставленную информацию, ее актуализации, в противном случае Администратор не несет
            ответственности за неисполнение обязательств, любые убытки, вред или потери.
          </p>
          <p>
            2.6.2. <strong>О представителях:</strong> Пользователь вправе разрешать, ограничивать или запрещать обработку
            персональных данных третьих лиц только на основании представительства, установленного законом (например,
            родители и опекуны) или сделкой (например, доверенность), дающего ему право давать разрешения на
            обработку персональной информации за третье лицо и нести иные права и обязанности в интересах такого
            третьего лица. Если Пользователь не имеет права дать такое разрешение или утратил право дать такое
            разрешение, то он обязан воздержаться от передачи данных или прекратить передачу данных (и удалить ранее
            переданные данные) соответственно, а в случае появления соответствующих претензий он обязуется
            самостоятельно разрешить противоречия и освободить Администратора от соответствующих требований. В
            случае несоблюдения этих требований Пользователь обязан возместить Администратору все убытки и иные
            потери, вызванные несоблюдением указанных требований.
          </p>
          <p className="bold">
            2.7. Дополнение, исправление, блокировка и удаление персональных данных, процедура реагирования на
            запросы субъекта на доступ к его персональным данным
          </p>
          <p>
            2.7.1. Пользователь может дополнить и исправить персональную информацию, воспользовавшись соответствующими
            функциями своей учетной записи, а если функции учетной записи не достаточны по мнению Пользователя
            &ndash; путем направления письменного обращения на адрес электронной почты Администратора, указанный в
            настоящей Политике.
          </p>
          <p>
            2.7.2. Пользователь может заблокировать и удалить персональную информацию, воспользовавшись соответствующими
            функциями своей учетной записи, а если функции учетной записи не достаточны по мнению Пользователя
            &ndash; путем направления письменного обращения на адрес электронной почты Администратора, указанный в
            настоящей Политике.
          </p>
          <p>
            2.7.3. Иные права субъекта персональных данных реализуются в аналогичном порядке: для реализации права
            Пользователь может воспользоваться соответствующими функциями своей учетной записи, а если функции
            учетной записи не достаточны по мнению Пользователя &ndash; путем направления письменного обращения на
            адрес электронной почты Администратора, указанный в настоящей Политике.
          </p>
          <p className="bold">
            2.7.4. Пользователь имеет право:
            <ul>
              <li>запрашивать информацию об осуществляемой обработке персональных данных;</li>
              <li>отзывать согласие на обработку персональной информации;</li>
              <li>требовать ограничений на обработку персональной информации;</li>
              <li>
                требовать прекратить обработку персональной информации, если это предусмотрено применимым законодательством и
                настоящей Политикой.
              </li>
            </ul>
          </p>
          <p>
            2.7.5. В случаях, предусмотренных применимым законодательством, Пользователь может также обладать другими
            правами, не указанными выше.
          </p>
          <p>
            2.7.6. Пользователь обязуется воспользоваться реквизитами (контактной информацией) из настоящей Политики для
            направления запросов о реализации прав субъекта персональных данных или жалоб относительно
            некорректности информации или незаконности ее обработки. Такие запросы и жалобы рассматриваются в срок,
            не превышающий 30 (Тридцати) календарных дней с даты поступления Администратору.
          </p>
          <p>
            2.7.7. Если Пользователь не удовлетворен результатами рассмотрения запроса или жалобы, то он имеет право подать
            запрос или жалобу в орган государственной власти, уполномоченный осуществлять защиту прав субъектов
            персональных данных.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Уведомления и связь сторон</SectionTitle>
        </li>
        <SectionContent>
          <p>
            3.1. Пользователь соглашается получать от Администратора сообщения по адресу электронной почты и по абонентскому
            номеру телефона, указанные Пользователем при использовании функций Платформы (далее &ndash; &laquo;Нотификации&raquo;).&nbsp;
          </p>
          <p>
            3.2. Пользователь вправе отозвать свое согласие на получение Нотификаций:
            <ul>
              <li>кликнув по ссылке &laquo;Отписаться&raquo; внизу письма;&nbsp;</li>
              <li>путем направления уведомления на электронную почту Администратора.</li>
            </ul>
          </p>
          <p>
            3.3. Пользователь согласен с тем, что Администратор прекращает направление Нотификаций не ранее чем через 24 часа
            после выполнения указанных действий.
          </p>
          <p>
            Администратор вправе использовать Нотификации для:
            <ul>
              <li>информирования Пользователя о работе функций Платформы;</li>
              <li>информирования Пользователя об изменении регулирующих документов;</li>
              <li>направления Пользователю сообщений и рассылок информационного характера;</li>
              <li>направления Пользователю сообщений и рассылок рекламного характера.</li>
            </ul>
          </p>
          <p>
            3.5. Пользователь в свою очередь обязуется направлять все сообщения, уведомления, заявления и документы (включая
            и сообщения, которые представляют собой ответы на Нотификации) по адресу электронной почты Администратора,
            указанному в настоящей Политике.
          </p>
          <p>
            3.6. Документы, которые по мнению Администратора имеют юридическое значение, Администратор вправе запросить в
            бумажном виде. Такие документы, а также документы, которые Пользователь сам считает необходимым направить в
            бумажном виде, направляются по адресу места нахождения Администратора, указанному в настоящей Политике.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Изменение Политики конфиденциальности. Применимое законодательство</SectionTitle>
        </li>
        <SectionContent>
          <p>
            4.1. Администратор имеет право вносить изменения в настоящую Политику. При внесении изменений в тексте актуальной
            редакции указывается дата последнего обновления. Новая редакция Политики вступает в силу с момента ее
            размещения, если иное не предусмотрено новой редакцией Политики. Утратившие силу редакции доступны в
            веб-архиве по указанному в Политике адресу.
          </p>
          <p>
            4.2. Местом выражения согласия с Политикой и местом исполнения Политики всегда является место нахождения
            Администратора, а правом, применимым к отношениям Администратора и Пользователя, всегда является право
            Республики Казахстан, вне зависимости от того, где находится Пользователь или оборудование, используемое им.
            Все споры и разногласия разрешаются по месту нахождения Администратора. Исключение составляют случаи, когда
            правоотношения Сторон подпадают под экстерриториальные критерии Общего регламента защиты данных Европейского
            союза (&laquo;GDPR&raquo; или &laquo;(ЕС) 2016/679&raquo;). В таком случае право, применимое к отношениям
            между Администратором и Пользователем, будет состоять в совокупности из законодательства Республики
            Казахстан и правил регламента GDPR, включая и правила разрешения споров и разногласий между участниками
            процесса обработки персональной информации.
          </p>
          <p>
            4.3. В случае, если Политика доступна на нескольких языках, правовой приоритет при толковании имеет версия на
            русском языке.
          </p>
          <p>
            4.4. Политика начинает регулировать отношения Пользователя и Администратора с момента выражения Пользователем
            согласия с ее условиями и действует бессрочно. Бессрочность действия Политики как документа никаким образом
            не означает бессрочность/отсутствие ограничений срока обработки персональных данных. Одностороннее
            прекращение действия Политики по воле одной из сторон не допускается.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Правила для Пользователей, находящихся в Европейском Союзе</SectionTitle>
        </li>
        <SectionContent>
          <p>
            5.1. В случае, если Вы разрешили своему оборудованию предоставлять данные о геолокации, и из
            содержимого этих данных Мы можем определить Ваше местоположение внутри Европейского Союза (ЕС), Мы обязаны
            предоставить Вам дополнительные права и гарантии в соответствии с Европейским общим регламентом защиты
            данных (&laquo;GDPR&raquo; или &laquo;(ЕС) 2016/679&raquo;), если правоотношения Сторон подпадают под его
            экстерриториальные критерии.
          </p>
          <p>
            5.2. Пользователь признает, что местоположение оборудования Пользователя, которое передает
            данные Администратору, должно быть единственным технически возможным способом идентифицировать Пользователя
            как резидента ЕС. Если Пользователь использует какие-либо средства для маскирования своего местоположения
            или какие-либо средства, которые потенциально могут вызвать такое маскирование, тогда Администратор не может
            идентифицировать Пользователя как Сторону, подпадающую под действие GDPR и, следовательно, отношения между
            Пользователем и Администратором не подлежат регулированию GDPR.
          </p>
          <p>
            5.3. Отношения между Пользователем и Администратором подпадают под действие GDPR с момента,
            когда Мы определяем Ваше местоположение в ЕС и до момента, когда Мы определяем Ваше новое местоположение за
            пределами ЕС.
          </p>
          <p>
            5.4. Основные права и гарантии GDPR для физических лиц следующие:&nbsp;
            <ul>
              <li>право на получение информации;</li>
              <li>право доступа;&nbsp;</li>
              <li>право на исправление;&nbsp;</li>
              <li>право на удаление;&nbsp;</li>
              <li>право на ограничение обработки;&nbsp;</li>
              <li>право на переносимость данных;&nbsp;</li>
              <li>право на возражение;&nbsp;</li>
              <li>права, связанные с автоматическим принятием решений (включая профилирование).</li>
            </ul>
          </p>
          <p>
            5.5. В случаях, предусмотренных применимым законодательством, Пользователь может также
            обладать другими правами и гарантиями, не указанными выше.
          </p>
          <p>
            5.6. Для реализации права или гарантии Пользователь может воспользоваться соответствующими
            функциями своей учетной записи, а если функции учетной записи не достаточны по мнению Пользователя &ndash;
            путем направления письменного обращения на адрес электронной почты Администратора, указанный в настоящей
            Политике.
          </p>
          <p>
            5.7. Если Администратор использует какую-либо стороннюю службу обработки данных для обработки
            персональных данных, он должен обеспечить полное соответствие обработчика данных требованиям GDPR и
            предоставить Пользователю запрошенную информацию о таком обработчике данных.
          </p>
          <p>
            5.8. Пользователь полностью осознает и принимает тот факт, что распространение правил GDPR на
            отношения Сторон никоим образом не влечет и не указывает на применение каких-либо иных актов
            законодательства Европейского Союза к отношениям Сторон.
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Реквизиты Администратора. Контактная информация</SectionTitle>
        </li>
        <SectionContent>
          <p>Товарищество с ограниченной ответственностью &quot;VIRTON (ВИРТОН)&quot;.</p>
          <p>050040, Казахстан, город Алматы, Бостандыкский район, улица Байзакова, здание 280, БИН 220340010538.</p>
          <p>
            Адрес электронной почты: <a href="mailto:hello@onlines.design">hello@onlines.design</a>
          </p>
        </SectionContent>
        <li>
          <SectionTitle>Сведения о редакции документа</SectionTitle>
        </li>
        <SectionContent>
          <p>Дата публикации этой редакции документа: 1 ноября 2022 г.</p>
        </SectionContent>
      </SectionsList>
    </>
  );
};
